module.exports = __webpack_public_path__ + "static/media/steamcouture-1.51f9cd29.jpg";